<div class="flex center" style="box-sizing: border-box; margin: 8px; overflow-x: hidden;">
    <div class="flex column page-border" #pdfContent>
        <img src={{logoPath}} class="trusts-logo" alt="trusts-logo" />

        <div class="doc-title">
            <p><strong><u>REGISTRATION OF FAMILY TRUST</u></strong></p>
            <p><u>CHECKLIST</u></p>
        </div>

        <div class="flex">
            <table id="data" mat-table [dataSource]="tableDataSource" matSort aria-label="Elements" class="table">
                <!-- Column definitions -->
                <ng-container *ngFor="let col of tableColumns" [matColumnDef]="col">
                    <th mat-header-cell *matHeaderCellDef [mat-sort-header]="getColumnName(col, tableColumns)" class="header">
                        {{ col == 'No' ? 'No.' : col == 'Status Comments' ? 'Status / Comments' : col }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="cells"
                        [ngStyle]="{'color': col == 'Status Comments' ? '#11B1EB !important'  : 'black',
                            'width':
                                col === 'No' || col === 'Tick' ? '30px' :
                                col === 'Document' ? '250px' :
                                col.toLowerCase().includes('responsible') ? '50px' : 'auto'
                        }"
                    >

                        {{ col == 'Tick' || col == 'Status Comments' ? '' : element[getColumnName(col, tableColumns)] }}
                        <!-- CHECKBOX -->
                        <mat-checkbox (click)="$event.stopPropagation(); $event.preventDefault()" *ngIf="col == 'Tick'"
                            (change)="$event ? toggleRow(element) : null"
                            [checked]="element.tick">
                        </mat-checkbox>
                        <!-- STATUS / COMMENTS -->
                        <form class="flex center comment-form" *ngIf="col == 'Status Comments'">
                            <mat-form-field class="comment-field" appearance="outline">
                                <input matInput>
                            </mat-form-field>
                        </form>
                    </td>
                </ng-container>

                <!-- Header row -->
                <tr mat-header-row *matHeaderRowDef="tableColumns" style="position: sticky;"></tr>

                <!-- Data rows -->
                <tr mat-row *matRowDef="let row; columns: tableColumns;" class="rows"></tr>
            </table>
        </div>
    </div>
</div>